module.exports = __webpack_public_path__ + "img/doc.4bc363ce.png";